import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AlQuran } from '../../types';

export type State = AlQuran[];

const initialState: State = [];

export const AlQuranSlice = createSlice({
  name: 'alquran',
  initialState,
  reducers: {
    onSetAlQuran: (state, action: PayloadAction<State>) => {
      const newState = [...state];
      for (const i of action.payload) {
        const index = newState.findIndex((o) => o.uid === i.uid);
        if (index === -1) {
          newState.push(i);
        } else {
          newState[index] = i;
        }
      }
      return newState.sort((a, b) => b.created_at - a.created_at);
    },
    onDeleteAlQuran: (state, action: PayloadAction<string[]>) => {
      return state.filter((s) => !action.payload.includes(s.uid));
    }
  }
});

export const { onSetAlQuran, onDeleteAlQuran } = AlQuranSlice.actions;

export default AlQuranSlice.reducer;
